<template>
  <div class="bgcolor">
    <csearch :searchName="searchName" :status="status" @pageChange="tapPage($event)"></csearch>
    <div
      class="loadmorediv"
      ref="wrapper"
      :style="{ height: wrapperHeight + 'px' }"
    >
      <mt-loadmore
        :top-method="Refresh"
        :bottom-method="Loading"
        ref="loadmore"
        topPullText="下拉刷新"
        topLoadingText="正在刷新"
        bottomPullText=""
        bottomDropText="释放加载"
        :bottom-all-loaded="allLoaded"
        :auto-fill="false"
      >
        <div
          class="ctdiv"
          v-for="item in dataList"
          :key="item.contractId"
          @click="goSignPage(item.contractId, item.statuss, item.status, item.seqNum)"
        >
          <div class="fl">
            <img class="ctimg" :src="getctimg(item.statuss)" />
          </div>
          <div class="fl">
            <div class="ctname">{{ item.contractName }}</div>
            <div class="ctdate">{{ item.statuss | formatStatus }}</div>
          </div>
          <div class="fr">
            <img
              class="ctrarrow"
              src="/static/img/user/center/rightArrow.png"
            />
          </div>
        </div>
        <div v-if='ts' class="ts2">没有更多数据啦！</div>
        <div v-if="dataList.length != 0 && !ts" class="ts2">上拉加载更多数据！</div>
        <div v-if="dataList.length == 0" class="nodata">
          暂无搜索记录
        </div>
      </mt-loadmore>
      <mt-popup
        class="mypopup"
        v-model="popupVisible"
        position="right">
        <div class="popupWrap">
            <h2>中宏云畅定制合同签署系统</h2>
            <p>您好，</p>
            <p>受东方银谷债委会委托，北京市金颐律师事务所代理出借人债权查证核实的相关工作。中宏云畅区块链技术有限公司作为东方银谷债委会指定的出借人的代理人，与出借人在线签订代理协议后，将与北京市金颐律师事务所签订委托协议。</p>
            <p>为此，中宏云畅区块链技术有限公司在壹签平台搭建在线电子合同签署平台——中宏云畅定制合同签署系统，并通过该系统向您发起了指定合同签署请求，请您务必在确定合同中的身份信息、合同内容无误后才开始签署操作。本合同的发起人设置由签署人支付合同签署的费用，费用为人民币柒元整（￥7.00），请在签署前完成支付。</p>
            <p> 若对合同内容及相关费用有疑问，请在签署前按照以下不同地区，联系相关负责人进行咨询：</p>
            <table class="table" border="0" cellpadding="0" cellspacing="0">
              <tr>
                <th>联系人</th>
                <th>地区</th>
                <th>手机号码</th>
              </tr>
              <tr>
                <td>云女士</td>
                <td>黑龙江</td>
                <td>15245334776</td>
              </tr>
              <tr>
                <td>段先生</td>
                <td>安徽</td>
                <td>13034023361</td>
              </tr>
              <tr>
                <td>曾女士</td>
                <td>山东</td>
                <td>13285333279</td>
              </tr>
              <tr>
                <td>冯先生</td>
                <td>江苏</td>
                <td>13952471984</td>
              </tr>
              <tr>
                <td>董女士</td>
                <td>北京、天津，河北，内蒙古</td>
                <td>13121814094</td>
              </tr>
              <tr>
                <td>林先生</td>
                <td>其他省份</td>
                <td>18928097060</td>
              </tr>
            </table>

            <div class="taocan">
              <h4>购买套餐为：</h4>
              <dl>
                <dt>套餐名称：</dt>
                <dd>{{companyName}}</dd>
              </dl>
              <dl>
                <dt>套餐次数：</dt>
                <dd>1次</dd>
              </dl>
              <dl>
                <dt>套餐金额：</dt>
                <dd>7.00元</dd>
              </dl>
            </div>
            <div class="btns">
              <span @click="popupVisible=false" class="close">关闭</span>
              <span @click="gopay" class="gopay">去支付</span>
            </div>
        </div>
      </mt-popup>

      <mt-popup
        class="mypopup"
        v-model="popupVisible2"
        position="right">
        <div class="popupWrap">
            <h2>中宏云畅定制合同签署系统</h2>
            <p>您好，</p>
            <p>该合同内的甲方姓名与您的实名认证姓名不符，请联系东方银谷债委会负责人进行咨询：</p>
            <table class="table" border="0" cellpadding="0" cellspacing="0">
              <tr>
                <th>联系人</th>
                <th>地区</th>
                <th>手机号码</th>
              </tr>
              <tr>
                <td>云女士</td>
                <td>黑龙江</td>
                <td>15245334776</td>
              </tr>
              <tr>
                <td>段先生</td>
                <td>安徽</td>
                <td>13034023361</td>
              </tr>
              <tr>
                <td>曾女士</td>
                <td>山东</td>
                <td>13285333279</td>
              </tr>
              <tr>
                <td>冯先生</td>
                <td>江苏</td>
                <td>13952471984</td>
              </tr>
              <tr>
                <td>董女士</td>
                <td>北京、天津，河北，内蒙古</td>
                <td>13121814094</td>
              </tr>
              <tr>
                <td>林先生</td>
                <td>其他省份</td>
                <td>18928097060</td>
              </tr>
            </table>
            <div class="btns">
              <span @click="popupVisible2=false" class="close">关闭</span>
            </div>
        </div>
      </mt-popup>

      <mt-popup
        class="mypopup mypopup2"
        v-model="popupVisible3"
        position="center">
        <div class="popupWrap">
            <h2>提示</h2>
            <p>合同发起人发起合同时添加的签署人名称与您实名认证的名称不一致，请联系发起人修改后重新发起签署！</p>
            <div class="btns">
              <span @click="popupVisible3=false" class="close">关闭</span>
            </div>
        </div>
      </mt-popup>
    </div>
  </div>
</template>
<script>
import csearch from "@/components/search";
import { Toast, MessageBox } from "mint-ui";
import { userStatus } from '@/config/userStatus'
export default {
  data() {
    return {
      allLoaded: false,
      page: 1,
      rows: 10,
      dataList: "",
      wrapperHeight: 0,
      ts:false,
      searchName:'',
      attestation:'',
      approveStatus:'',
      status:'',
      popupVisible:false,
      popupVisible2:false,
      popupVisible3:false,
      idCard:'',
      companyName:'',
      payid:'',
    };
  },
  created(){
    this.fetcchMsg();
  },
  mounted() {
    this.status =localStorage.getItem("clist_status");
    this.wrapperHeight = document.documentElement.clientHeight - 46 - 53;
    var clist_status = localStorage.getItem("clist_status");
    if (clist_status == 1) {
      this.getdtotalData();
    } else if (clist_status == 2) {
      this.getdwqsData();
    } else if (clist_status == 3) {
      this.getdtrqsData();
    } else if (clist_status == 4) {
      this.getywcData();
    } else if (clist_status == 5) {
      this.getcgxData();
    } else if (clist_status == 6) {
      this.getqtData();
    } else {
      this.getdtotalData();
    }
  },
  watch: {
    contractstatus: function() {
      if (this.contractstatus == "1") {
        this.status='2';
        localStorage.setItem("clist_status", '2');
        this.getdwqsData();
      } else if (this.contractstatus == "2") {
        this.status='3';
        localStorage.setItem("clist_status", '3');
        this.getdtrqsData();
      } else {
        this.status='1';
        localStorage.setItem("clist_status", '1');
        this.getdtotalData();
      }
    }
  },
  methods: {
    tapPage(e) {
      this.page = 1;
      this.allLoaded=false;
      this.searchName=e;
    },
    async Refresh() {
      this.allLoaded=false;
      this.page = 1;
      var clist_status = localStorage.getItem("clist_status");
      if (clist_status == 1) {
        await this.getdtotalData(false,this.searchName);
      } else if (clist_status == 2) {
        await this.getdwqsData(false,this.searchName);
      } else if (clist_status == 3) {
        await this.getdtrqsData(false,this.searchName);
      } else if (clist_status == 4) {
        await this.getywcData(false,this.searchName);
      } else if (clist_status == 5) {
        await this.getcgxData(false,this.searchName);
      } else if (clist_status == 6) {
        await this.getqtData(false,this.searchName);
      } else {
        await this.getdtotalData(false,this.searchName);
      }
      this.$refs.loadmore.onTopLoaded();
    },
    async Loading() {
      this.page=this.page+1;
      var clist_status = localStorage.getItem("clist_status");
      if (clist_status == 1) {
        await this.getdtotalData(true,this.searchName);
      } else if (clist_status == 2) {
        await this.getdwqsData(true,this.searchName);
      } else if (clist_status == 3) {
        await this.getdtrqsData(true,this.searchName);
      } else if (clist_status == 4) {
        await this.getywcData(true,this.searchName);
      } else if (clist_status == 5) {
        await this.getcgxData(true,this.searchName);
      } else if (clist_status == 6) {
        await this.getqtData(true,this.searchName);
      } else {
        await this.getdtotalData(true,this.searchName);
      }
      this.$refs.loadmore.onBottomLoaded();
    },
    gopay(){
      this.$router.push({
         path: "/combo/createOrder",
         name: 'createOrder',
         query:{
           id:this.payid
         }
       })
    },
    async goSignPage(cid, status, cs, seqNum){
      this.$http.post(domain("_mainIndex"),{emulateJSON: true}).then(async function (response) {
        let { approveStatus = '0' } = response.body.data || {}
        this.approveStatus = approveStatus
        let { statusCode } = await userStatus(this.approveStatus, ['1', '2', '3', '4', '5', '6', '7', '8'], () => {
          if (this.approveStatus === '2' || this.approveStatus === '5') {
            MessageBox.confirm('', { 
                 message: '您还未通过实名认证，请先通过实名认证！', 
                 title: '提示', 
                 confirmButtonText: '去认证', 
                 cancelButtonText: '取消' 
              }).then(action => { 
                  if (action == 'confirm') {
                    this.$router.push({
                      path: '/realName',
                      query: {
                        type: 'ENTERPRISE'
                      }
                    })
                  }
              }).catch(err => { 
                  if (err == 'cancel') {
                   console.log('取消');
                  } 
              });
          } else if (this.approveStatus === '3' || this.approveStatus === '4' || this.approveStatus === '6') {
            MessageBox.confirm('', { 
                 message: '根据平台要求，您需要完善企业实名信息后方可继续签约', 
                 title: '提示', 
                 confirmButtonText: '去完善', 
                 cancelButtonText: '取消' 
              }).then(action => { 
                  if (action == 'confirm') {
                    this.$router.push({
                      path: '/realName',
                      query: {
                        type: 'ENTERPRISE'
                      }
                    })
                  }
              }).catch(err => { 
                  if (err == 'cancel') {
                   console.log('取消');
                  } 
              });
          } else if (this.approveStatus === '8') {
            MessageBox.confirm('', { 
                 message: '根据平台要求，您需要完善个人实名信息后方可继续签约', 
                 title: '提示', 
                 confirmButtonText: '去完善', 
                 cancelButtonText: '取消' 
              }).then(action => { 
                  if (action == 'confirm') {
                    this.$router.push({
                      path: '/realName',
                      query: {
                        type: 'PERSON',
                        identifyType: '1'
                      }
                    })
                  }
              }).catch(err => { 
                  if (err == 'cancel') {
                   console.log('取消');
                  } 
              });
          }
        })
        if (!statusCode) return
        console.log('$$$$$$$$$$$$$$')
        let that=this;
        // if(that.approveStatus=='0' || that.approveStatus=='2' || that.approveStatus=='5'){
        //   MessageBox.confirm('', { 
        //     message: '根据平台要求，您需实名认证后方可继续签约', 
        //     title: '提示', 
        //     confirmButtonText: '去认证', 
        //     cancelButtonText: '取消' 
        // }).then(action => { 
        //     if (action == 'confirm') {
        //       var cusType = localStorage.getItem("cusType");
        //       if(cusType=="2"){
        //         Toast("该帐号只可企业实名认证");
        //         return;
        //       }
        //       that.$router.push({
        //         path: '/user/approval',
        //       })
        //     }
        // }).catch(err => { 
        //     if (err == 'cancel') {
        //       console.log('取消');
        //     } 
        // });
        //     // that.$toast("您尚未实名认证！");
        //     return false;
        // }else if(that.approveStatus=='3' || that.approveStatus=='4' || that.approveStatus=='6'){
        //     that.$toast("根据平台要求，您需要到pc端完善企业实名信息后方可继续签约");
        //     return false;
        // }else if(that.approveStatus==''){
        //     that.$toast("服务异常，请您稍后再试");
        //     return false;
        // }

        // if(this.attestation=='8'){
        //   MessageBox.confirm('', { 
        //        message: '根据平台要求，您需要完善个人实名信息后方可继续签约', 
        //        title: '提示', 
        //        confirmButtonText: '去完善', 
        //        cancelButtonText: '取消' 
        //     }).then(action => { 
        //         if (action == 'confirm') {
        //           that.$router.push({
        //             path:"/user/approval",
        //             query:{
        //               attestation:that.attestation
        //             }
        //           });
        //         }
        //     }).catch(err => { 
        //         if (err == 'cancel') {
        //          console.log('取消');
        //         } 
        //     });
        //     return false;
        // }

        // if((status=='5' || status=='2') && (this.attestation == '5'|| this.attestation == '6' || this.attestation == '2'|| this.attestation == '4')){
        //     MessageBox.confirm('', { 
        //        message: '根据平台要求，您需要进行实名认证后方可继续查看', 
        //        title: '提示', 
        //        confirmButtonText: '去实名', 
        //        cancelButtonText: '取消' 
        //     }).then(action => { 
        //         if (action == 'confirm') {
        //           that.$router.push({
        //             path:"/user/approval",
        //           });
        //         }
        //     }).catch(err => { 
        //         if (err == 'cancel') {
        //          console.log('取消');
        //         } 
        //     });
        //     return false;
        // }


        if(cs == "2" && seqNum!==1){
          let pass;
            await that.$http
              .post(domain("_judgeContractIsLaw"), {
                contractId: cid
              })
              .then(
                function(response) {
                  console.log(response);
                  if(response.data.code==999){
                    pass=true;
                    that.idCard=response.data.data.idCard
                    that.$http
                      .post(domain("_comboSearch"))
                      .then(
                        function(response) {
                          console.log(response);
                          that.companyName=response.data.data.rows[0].name,
                          that.payid=response.data.data.rows[0].id,
                          that.popupVisible=true
                        },
                      )
                  }else if(response.data.code==1){
                    Toast("服务异常，请稍后再试")
                    pass=true;
                  }else if(response.data.code==2){
                    that.popupVisible2=true;
                    pass=true;
                  }else if(response.data.code==3){
                    that.popupVisible3=true;
                    pass=true;
                  }
                  else{
                    pass=false;
                  }
                },
              )
            if(pass){
              return false
            }
        }

        if(status == "6"){
            if (cs == "0") {
                that.$router.push({ name: "addsigner", query: { cid: cid } });
                return true;
            }
        }
        if(status !== "1" && status !== "6"){
            that.$router.push({ name: "detail", query: { cid: cid } });
            return true;
        }
        if(status=='1'){
            that.$router.push({ name: "sign", query: { cid: cid } });
            return false;
        }
        
        //待我签署
        that.$http
          .post(domain("_initiate"), {
            contractId: cid
          })
          .then(
            function(response) {
              console.log(response);
              if(response.data.code=='0'){
                  that.$router.push({ name: "dsign", query: { cid: cid } });
              }else if(response.data.code == "5"){
                  MessageBox.confirm("", {
                    message: "套餐余额不足，请先购买套餐后进行签署！",
                    title: "提示",
                    confirmButtonText: "去购买",
                    cancelButtonText: "取消"
                  })
                    .then(action => {
                      if (action == "confirm") {
                        that.$router.push("/combo/buyCombo");
                      }
                    })
                    .catch(err => {
                      if (err == "cancel") {
                        console.log("取消");
                      }
                    });
              }else{
                  that.$toast(response.data.msg);
              }
              
            },
            function(error) {
              console.log(error);
            }  
          ) 
      })   
    },
    // goSignPage: function(cid, status, cs) {
    //   if (status == "1") {
    //     var that = this;
    //     that.$http
    //       .post(domain("_judge3"), {
    //         contractId: cid
    //       })
    //       .then(
    //         function(response) {
    //           if (response.data.code == "0") {
    //             that.$router.push({ name: "dsign", query: { cid: cid } });
    //           } else if (response.data.code == "5") {
    //             MessageBox.confirm("", {
    //               message: "套餐余额不足，请先购买套餐后进行签署！",
    //               title: "提示",
    //               confirmButtonText: "去购买",
    //               cancelButtonText: "取消"
    //             })
    //               .then(action => {
    //                 if (action == "confirm") {
    //                   that.$router.push("/combo/buyCombo");
    //                 }
    //               })
    //               .catch(err => {
    //                 if (err == "cancel") {
    //                   console.log("取消");
    //                 }
    //               });
    //           } else {
    //             that.$toast(response.data.msg);
    //             return;
    //           }
    //           that.dataList = response.data.data;
    //         },
    //         function(error) {
    //           console.log(error);
    //         }
    //       );
    //   } else if (status == "6") {
    //     var that = this;
    //     that.$http
    //       .post(domain("_judge2"), {
    //         contractId: cid
    //       })
    //       .then(
    //         function(response) {
    //           console.log(response);
    //           if (response.data.code == "0") {
    //             if (cs == "0") {
    //               that.$router.push({ name: "addsigner", query: { cid: cid } });
    //             } else {
    //               that.$router.push({ name: "sign", query: { cid: cid } });
    //             }
    //           } else if (response.data.code == "5") {
    //             MessageBox.confirm("", {
    //               message: "套餐余额不足，请先购买套餐后进行签署！",
    //               title: "提示",
    //               confirmButtonText: "去购买",
    //               cancelButtonText: "取消"
    //             })
    //               .then(action => {
    //                 if (action == "confirm") {
    //                   that.$router.push("/combo/buyCombo");
    //                 }
    //               })
    //               .catch(err => {
    //                 if (err == "cancel") {
    //                   console.log("取消");
    //                   return;
    //                 }
    //               });
    //           } else {
    //             that.$toast(response.data.msg);
    //             return;
    //           }
    //           //that.dataList=response.data.data;
    //         },
    //         function(error) {
    //           console.log(error);
    //         }
    //       );
    //   } else {
    //     var that = this;
    //     that.$http
    //       .post(domain("_judge3"), {
    //         contractId: cid
    //       })
    //       .then(
    //         function(response) {
    //           if (response.data.code == "0") {
    //             that.$router.push({ name: "detail", query: { cid: cid } });
    //           } else if (response.data.code == "5") {
    //             MessageBox.confirm("", {
    //               message: "套餐余额不足，请先购买套餐后进行签署！",
    //               title: "提示",
    //               confirmButtonText: "去购买",
    //               cancelButtonText: "取消"
    //             })
    //               .then(action => {
    //                 if (action == "confirm") {
    //                   that.$router.push("/combo/buyCombo");
    //                 }
    //               })
    //               .catch(err => {
    //                 if (err == "cancel") {
    //                   console.log("取消");
    //                 }
    //               });
    //           } else {
    //             that.$toast(response.data.msg);
    //             return;
    //           }
    //           that.dataList = response.data.data;
    //         },
    //         function(error) {
    //           console.log(error);
    //         }
    //       );
    //   }
    // },
    getdtotalData: function(flag=false, param ='') {
      if (!param) {
        param = "";
      }
      var that = this;
      that.$http
        .post(domain("_total"), {
          contractName: param,
          page: that.page,
          rows: that.rows
        })
        .then(
          function(response) {
            console.log(response);
            if (flag) {
              that.dataList = [...that.dataList, ...response.data.data.rows];
            } else {
              that.dataList = response.data.data.rows;
            }
            if(response.data.data.totalPage==that.page){
              that.ts=true;
              that.allLoaded=true;
            }else{
              that.ts=false
            }
            that.approveStatus=response.data.data.approveStatus;
          },
          function(error) {
            console.log(error);
          }
        );
    },
    getdwqsData: function(flag, param ='') {
      if (!param) {
        param = "";
      }
      var that = this;
      that.$http
        .post(domain("_dwqs"), {
          contractName: param,
          page: that.page,
          rows: that.rows
        })
        .then(
          function(response) {
              console.log(response);
            if (flag) {
              that.dataList = [...that.dataList, ...response.data.data.rows];
            } else {
              that.dataList = response.data.data.rows;
            }
            if(response.data.data.totalPage==that.page){
              that.ts=true;
              that.allLoaded=true;
            }else{
              that.ts=false
            }
            that.approveStatus=response.data.data.approveStatus;
            that.dataList.map(function(item, index) {
              item.statuss = "1";
            });
          },
          function(error) {
            console.log(error);
          }
        );
    },
    getdtrqsData: function(flag, param ='') {
      // alert(this.approveStatus)
      if (!param) {
        param = "";
      }
      var that = this;
      that.$http
        .post(domain("_dtrqs"), {
          contractName: param,
          page: that.page,
          rows: that.rows
        })
        .then(
          function(response) {
            if (flag) {
              that.dataList = [...that.dataList, ...response.data.data.rows];
            } else {
              that.dataList = response.data.data.rows;
            }
            if(response.data.data.totalPage==that.page){
              that.ts=true;
              that.allLoaded=true;
            }else{
              that.ts=false
            }
            that.dataList.map(function(item, index) {
              item.statuss = "2";
            });
          },
          function(error) {
            console.log(error);
          }
        );
    },
    getywcData: function(flag, param ='') {
      if (!param) {
        param = "";
      }
      var that = this;
      that.$http
        .post(domain("_ywc"), {
          contractName: param,
          page: that.page,
          rows: that.rows
        })
        .then(
          function(response) {
            console.log(response);
            if (flag) {
              that.dataList = [...that.dataList, ...response.data.data.rows];
            } else {
              that.dataList = response.data.data.rows;
            }
            if(response.data.data.totalPage==that.page){
              that.ts=true;
              that.allLoaded=true;
            }else{
              that.ts=false
            }
            that.dataList.map(function(item, index) {
              item.statuss = "3";
            });
          },
          function(error) {
            console.log(error);
          }
        );
    },
    getcgxData: function(flag, param ='') {
      if (!param) {
        param = "";
      }
      var that = this;
      that.$http
        .post(domain("_cgx"), {
          contractName: param,
          page: that.page,
          rows: that.rows
        })
        .then(
          function(response) {
            if (flag) {
              that.dataList = [...that.dataList, ...response.data.data.rows];
            } else {
              that.dataList = response.data.data.rows;
            }
            if(response.data.data.totalPage==that.page){
              that.ts=true;
              that.allLoaded=true;
            }else{
              that.ts=false
            }
            that.dataList.map(function(item, index) {
              item.statuss = "6";
            });
          },
          function(error) {
            console.log(error);
          }
        );
    },
    getqtData: function(flag, param ='') {
      if (!param) {
        param = "";
      }
      var that = this;
      that.$http
        .post(domain("_qt"), {
          contractName: param,
          page: that.page,
          rows: that.rows
        })
        .then(
          function(response) {
            if (flag) {
              that.dataList = [...that.dataList, ...response.data.data.rows];
            } else {
              that.dataList = response.data.data.rows;
            }
            if(response.data.data.totalPage==that.page){
              that.ts=true;
              that.allLoaded=true;
            }else{
              that.ts=false
            }
          },
          function(error) {
            console.log(error);
          }
        );
    },
    getctimg: function(param) {
      switch (param) {
        case "1":
          return "/static/img/contract/dwqs.png";
          break;
        case "2":
          return "/static/img/contract/dtrqs.png";
          break;
        case "3":
          return "/static/img/contract/ywc.png";
          break;
        case "4":
          return "/static/img/contract/yqx.png";
          break;
        case "5":
          return "/static/img/contract/ygq.png";
          break;
        case "6":
          return "/static/img/contract/cgx.png";
          break;
        case "7":
          return "/static/img/contract/yjj.png";
          break;
        default:
          return "error";
          break;
      }
    },
    fetcchMsg: function () {
      let that=this;
      var _mainIndex_Url = domain("_mainIndex"); //个人中心数据
      // console.log('我被执行了---ContractList---')
      this.$http.post(
        _mainIndex_Url,
        {emulateJSON: true}
        )
        .then(function (response) {
          // console.log(response)
          // console.log('*******************')
          var code = response.data.code;
          var msg = response.data.msg;
          if (code == '0') {
            var returnDate = response.data.data;
            that.attestation=returnDate.approveStatus;
            that.approveStatus=returnDate.approveStatus;
          } else {
            Toast(msg)
          }
        }, function (error) {
          console.log(error);
        }).catch(function (response) {
          console.log(response);
      })
    },
  },
  filters: {
    formatDate(times) {
      var mydate = new Date(times);
      return mydate.format("yyyy-MM-dd hh:mm:ss");
    },
    formatStatus(value) {
      switch (value) {
        case "1":
          return "待我签";
          break;
        case "2":
          return "待他人签";
          break;
        case "3":
          return "已完成";
          break;
        case "4":
          return "已取消";
          break;
        case "5":
          return "已过期";
          break;
        case "6":
          return "草稿箱";
          break;
        case "7":
          return "已拒签";
          break;
        default:
          return "error";
          break;
      }
    }
  },
  props: {
    contractstatus: String
  },
  components: {
    csearch
  }
};
</script>

<style>
.ts2{
  text-align: center;
  font-size: 16px;
  color:#999;
  padding: 20px 0;
  margin-top:0;
}
.loadmorediv {
  overflow: auto;
}
.loadmorediv .ctdiv {
  background-color: #ffffff;
  text-align: left;
  height: 54px;
  margin-top: 1px;
  padding: 12px 0 0 20px;
}
.ctdiv .ctdate {
  margin-top: 2px;
  font-size: 0.8rem;
  color: #c1c1c1;
}
.ctdiv .ctname {
  color: #7d7d7d;
  font-size: 0.9rem;
  max-width: 200px;
  margin-top: 5px;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis;
}
@media screen and (min-device-width: 321px) and (max-device-width: 360px) {
  .ctdiv .ctname {
    max-width: 210px;
  }
}
@media screen and (min-device-width: 361px) {
  .ctdiv .ctname {
    max-width: 240px;
  }
}
@media screen and (max-device-width: 320px) {
  .ctdiv .ctname {
    max-width: 180px;
  }
}
.ctstatus {
  background-color: #90c9f2;
  width: 54px;
  height: 20px;
  line-height: 20px;
  color: #ffffff;
  font-size: 0.7rem;
  text-align: center;
  margin: -12px 0 14px 0;
}
.ctrarrow {
  width: 9px;
  float: right;
  margin: 16px;
}
.nodata {
  text-align: center;
  font-size: 1.4rem;
  color: #c1c1c1;
  margin-top: 50%;
}
.ctimg {
  width: 24px;
  height: 28px;
  margin: 13px 15px 0 0;
}
.mypopup{
  width:100%;
  height: 100%;
  background:#fff;
  overflow: auto;
}
.mypopup2{
    width: 80%;
    height:300px;
}

.popupWrap{
  padding:40px 20px 20px;
}
.popupWrap h2{
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
}
.popupWrap p{
  text-indent: 2em;
  line-height: 30px;
  font-size: 14px;
}
.taocan{
  margin-top:30px;
  font-size: 14px;
}
.taocan h4{
  margin-bottom: 20px;
}
.taocan dl{
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  padding-left: 30px;
}
.taocan dt{
  color:#000;
}
.taocan dd{
  color:#666
}
.btns{
  text-align: center;
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content:space-around;
}
.btns span{
  width:120px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  font-size: 16px;
  border-radius: 5px;
}
.close{
  border:1px solid #ccc;
}
.gopay{
  background:#26a2ff;
  border:1px solid #26a2ff;
  color:#fff
}

.table{
  width: 100%;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  font-size: 14px;
}
.table th,.table td{
  text-align: left;
  border-right:1px solid #ccc;
  border-bottom:1px solid #ccc;
  padding:5px;
}
</style>



// WEBPACK FOOTER //
// src/module/contract/ContractList.vue